import React from 'react';
const CTAButton = () => {
  return <a href="https://myaethra.com/products/myaethra-hajstimulator?utm_source=myaethra.hu&utm_medium=referral&utm_campaign=hu_website" className="w-full bg-[#804C5C] hover:bg-[#804C5C]/90 text-white font-bold py-3 px-4 rounded-lg transition duration-200 flex justify-center items-center shadow-lg" data-id="element-205">
      IRÁNY A BOLT!
    </a>;
};
export default CTAButton;